import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProviders } from 'next-auth/react';

const getSocialProvidersThunk = createAsyncThunk(
  'profile/getSocialProviders',
  async () => {
    return await getProviders();
  },
);

export default getSocialProvidersThunk;
